import React, { useEffect, useState } from "react";

import CmsPreviewShell from "./CmsPreviewShell";
import mockData from "./mockData.json";

import type { CmsComponentProps, EventMock } from "./types";

const formatCountdown = (endAt?: string): string | null => {
  if (!endAt) return null;
  const end = new Date(endAt).getTime();
  const diff = end - Date.now();
  if (Number.isNaN(end) || diff <= 0) return "마감";
  const days = Math.floor(diff / 86_400_000);
  const hours = Math.floor((diff % 86_400_000) / 3_600_000);
  const mins = Math.floor((diff % 3_600_000) / 60_000);
  if (days > 0) return `${days}일 ${hours}시간 남음`;
  if (hours > 0) return `${hours}시간 ${mins}분 남음`;
  return `${mins}분 남음`;
};

const EventComponent: React.FC<CmsComponentProps> = ({ title, layout, items: userItems }) => {
  const items: EventMock[] =
    userItems && userItems.length > 0
      ? userItems
          .filter((i) => i.is_active !== false)
          .map((i, idx) => ({
            id: idx,
            title: i.title,
            description: i.description ?? "",
            img: i.img ?? "",
            badge: i.badge ?? "",
            period: i.start_at && i.end_at ? `${i.start_at.slice(0, 10)} ~ ${i.end_at.slice(0, 10)}` : "",
            badgeColor: i.badge_color,
            endAt: i.end_at,
          }))
      : (mockData.event as EventMock[]);
  const [, setTick] = useState(0);

  useEffect(() => {
    if (!items.some((i) => i.endAt)) return;
    const timer = setInterval(() => setTick((t) => t + 1), 60_000);
    return () => clearInterval(timer);
  }, [items]);

  return (
    <CmsPreviewShell title={title}>
      <div className={`cms-event cms-event--${layout}`}>
        {items.map((item) => {
          const countdown = formatCountdown(item.endAt);
          const badgeColor = item.badgeColor ?? "red";
          return (
            <div key={item.id} className="cms-event__item">
              <div className="cms-event__image">
                {item.img ? <img src={item.img} alt={item.title} /> : <div className="cms-event__placeholder">이미지 없음</div>}
                {item.badge && <span className={`cms-event__badge cms-event__badge--${badgeColor}`}>{item.badge}</span>}
                {countdown && <span className="cms-event__countdown">⏱ {countdown}</span>}
              </div>
              <div className="cms-event__body">
                <h5 className="cms-event__title">{item.title}</h5>
                {item.description && <p className="cms-event__desc">{item.description}</p>}
                {item.period && <span className="cms-event__period">{item.period}</span>}
                {!isNaN(Number(item.price)) && <p className="cms-event__price">{Number(item.price).toLocaleString("ko-KR") + "원"}</p>}
              </div>
            </div>
          );
        })}
      </div>
    </CmsPreviewShell>
  );
};

export default EventComponent;
